import "html2canvas/dist/html2canvas.min.js";
import "moment";
import "./bower_components/chart.js/dist/Chart.min.js";
import "./bower_components/Babel-Polyfill-Standalone/babel-polyfill.min.js";

import {UrlService} from '@uirouter/angular';

import {FI_VERSION} from "./version";

console.info("Application version: " + FI_VERSION);

import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {FiAppModule} from '@fi-app/fi-app.module';

import {environment} from "./environments/environment";
import {enableProdMode, NgZone} from "@angular/core";

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(FiAppModule, {
    preserveWhitespaces: true,
}).then(platformRef => {
    platformRef.injector.get(NgZone).run(() => {
        const urlService = platformRef.injector.get(UrlService);
        urlService.listen();
    });
});
